import ReCAPTCHA from "react-google-recaptcha";
import { useRef } from "react";
import { recaptchaKey } from "core/common/constants/env";
import useStore from "core/custom-hooks/useStore";
import { setRecaptcha } from "core/store/actionCreators";

const Recaptcha = () => {
    const ref = useRef();
    const { dispatch, state } = useStore();
    const { recaptcha: recaptchaData } = state;
    const { handleRecaptchaResponse, submitRef } = recaptchaData;

    return (
        <ReCAPTCHA
            sitekey={recaptchaKey}
            size="invisible"
            ref={el => { ref.current = el; }}
            onErrored={(err) => alert("לא ניתן לאמת שאינך רובוט")}
            onExpired={() => handleRecaptchaResponse("")}
            asyncScriptOnLoad={() => dispatch(setRecaptcha({ recaptchaRef: ref.current }))}
            onChange={(res) => {
                handleRecaptchaResponse(res);
                submitRef?.current?.click();
            }}
        />
    );
};

export default Recaptcha;